import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'validatedData': {
    'data': null,
    'loading': false,
  },
};

export const vehiclesPriceColorLoad = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.VALIDATING_PRICES_DATA]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': true,
      },
    }),
    [ActionTypes.VALIDATED_PRICES_DATA]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': action.response.data,
        'loading': false,
      },
    }),
    [ActionTypes.VALIDATE_PRICES_DATA_FAILED]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': false,
      },
    }),

    [ActionTypes.SAVING_MULTIPLE_COLOR_PRICES]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': true,
      },
    }),
    [ActionTypes.SAVED_MULTIPLE_COLOR_PRICES]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': false,
      },
    }),
    [ActionTypes.SAVE_MULTIPLE_COLOR_PRICES_FAILED]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': false,
      },
    }),

    [ActionTypes.CLEAN_PRICES_DATA]: (state, action) => ({
      ...state,
      'validatedData': {
        'data': null,
        'loading': false,
      },
    }),

    
  })(state, action);
};
